/*
 * 見学ツアー申込フォーム（sections/tour-booking.liquid）
 * 外部ライブラリなし。
 *
 * - 残枠: Liquid で埋め込んだ在庫を初期値にし、Section Rendering API で最新値に上書きする
 * - 締切: 開催日の前日 23:59:59（Asia/Tokyo）まで。基準時刻はサーバ時刻＋ページ表示後の経過時間
 * - 送信: /cart/add.js → /checkout（カートページは通さない）
 */
(function () {
  'use strict';

  if (customElements.get('tour-booking')) return;

  var WEEKDAYS = ['日', '月', '火', '水', '木', '金', '土'];
  var JST_OFFSET_MS = 9 * 60 * 60 * 1000;
  var CAR_METHOD = '自家用車';

  var KANA_RE = /^[ぁ-ゟ゠-ヿ･-ﾟ\s　]+$/;

  var MESSAGES = {
    date: '開催日を選択してください。',
    method: '参加方法を選択してください。',
    qty: '申込人数を選択してください。',
    qtyOver: '申込人数が残枠を超えています。人数を選び直してください。',
    consent: '自家用車で参加される場合は、同意にチェックを入れてください。',
    name: '代表者氏名を入力してください。',
    kanaEmpty: 'フリガナを入力してください。',
    kana: 'フリガナはカタカナまたはひらがなで入力してください（スペースは使えます）。',
    telEmpty: '電話番号を入力してください。',
    telChars: '電話番号は数字とハイフンのみで入力してください。',
    telDigits: '電話番号は10〜11桁で入力してください。',
    closed: '選択された日程は受付を締め切りました。別の日程をお選びください。',
    soldOut:
      '選択された日程・参加方法の残枠が足りないため、お申し込みできませんでした。最新の残枠を表示しましたので、日程・参加方法・人数を選び直してください。',
    network: '通信エラーが発生しました。時間をおいて、もう一度お試しください。',
    lostSelection: '選択していた日程は受付を終了したか満席になりました。別の日程をお選びください。'
  };

  /* ---------- 日付・時刻 ---------- */

  function parseIso(iso) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso || '');
    return m ? { y: +m[1], m: +m[2], d: +m[3] } : null;
  }

  // 開催日 0:00(JST) のエポックミリ秒。この時刻に達したら締切
  function deadlineMs(iso) {
    var p = parseIso(iso);
    return p ? Date.UTC(p.y, p.m - 1, p.d) - JST_OFFSET_MS : -Infinity;
  }

  // snippets/tour-date-label.liquid と同じ書式
  function formatDate(iso, style) {
    var p = parseIso(iso);
    if (!p) return iso || '';
    var wd = WEEKDAYS[new Date(Date.UTC(p.y, p.m - 1, p.d)).getUTCDay()];
    var body = style === 'short' ? p.m + '/' + p.d : p.y + '年' + p.m + '月' + p.d + '日';
    return body + '(' + wd + ')';
  }

  // 端末の時計は使わず「サーバ時刻 + 同期してからの経過時間」で現在時刻を求める
  // 検証用: ?tour_time_offset=秒 で時計を未来へだけずらせる（締切を早めることしかできない）
  var testOffsetSec = Math.max(0, parseInt(new URLSearchParams(location.search).get('tour_time_offset'), 10) || 0);

  var clock = {
    base: 0,
    at: 0,
    sync: function (serverSec) {
      this.base = (serverSec + testOffsetSec) * 1000;
      this.at = performance.now();
    },
    now: function () {
      return this.base + (performance.now() - this.at);
    }
  };

  function isOpen(iso) {
    return clock.now() < deadlineMs(iso);
  }

  /* ---------- 在庫データ ---------- */

  // バリエーション配列 → 日付ごとの { date, stocks: {参加方法: 残数}, total }（日付昇順）
  function buildSchedule(data) {
    var byDate = {};
    var list = [];
    data.variants.forEach(function (v) {
      if (!v.date || !v.method) return;
      var entry = byDate[v.date];
      if (!entry) {
        entry = byDate[v.date] = { date: v.date, stocks: {}, total: 0 };
        list.push(entry);
      }
      var n = Math.max(0, v.stock | 0);
      entry.stocks[v.method] = n;
      entry.total += n;
    });
    list.sort(function (a, b) {
      return a.date < b.date ? -1 : a.date > b.date ? 1 : 0;
    });
    return { list: list, byDate: byDate };
  }

  // 次回 = 受付中で残枠がある最も早い日。全部満席なら受付中の最も早い日
  function nextEntry(openList) {
    for (var i = 0; i < openList.length; i++) {
      if (openList[i].total > 0) return openList[i];
    }
    return openList[0] || null;
  }

  // snippets/tour-next.liquid と同じ書式
  function nextText(entry, style) {
    if (!entry) return style === 'short' ? '' : '現在受付中の日程はありません';
    if (style === 'short') {
      return '次回 ' + formatDate(entry.date, 'short') + ' ' + (entry.total > 0 ? '残' + entry.total + '名' : '満席');
    }
    return '次回開催 ' + formatDate(entry.date, 'long') + ' ' + (entry.total > 0 ? '残り' + entry.total + '名' : '満席');
  }

  function readData(root) {
    var el = root.querySelector('[data-tour-data]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function stockKey(data) {
    return data.variants
      .map(function (v) {
        return v.id + ':' + v.stock;
      })
      .join(',');
  }

  function datesKey(data) {
    var seen = {};
    data.variants.forEach(function (v) {
      if (v.date) seen[v.date] = true;
    });
    return Object.keys(seen).sort().join(',');
  }

  /* ---------- 入力チェック ---------- */

  // 全角数字・各種ダッシュを半角にそろえる
  function normalizeTel(value) {
    return value
      .replace(/[０-９]/g, function (c) {
        return String.fromCharCode(c.charCodeAt(0) - 0xfee0);
      })
      .replace(/[‐‑‒–—―−－ｰー]/g, '-')
      .replace(/[\s　]/g, '');
  }

  var VALIDATORS = {
    name: function (v) {
      return v.trim() ? '' : MESSAGES.name;
    },
    kana: function (v) {
      var t = v.trim();
      if (!t) return MESSAGES.kanaEmpty;
      return KANA_RE.test(t) ? '' : MESSAGES.kana;
    },
    tel: function (v) {
      var t = normalizeTel(v);
      if (!t) return MESSAGES.telEmpty;
      if (!/^[0-9-]+$/.test(t)) return MESSAGES.telChars;
      var digits = t.replace(/-/g, '').length;
      return digits >= 10 && digits <= 11 ? '' : MESSAGES.telDigits;
    }
  };

  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* ---------- カスタム要素 ---------- */

  class TourBooking extends HTMLElement {
    connectedCallback() {
      this.data = readData(this);
      if (!this.data) return;
      clock.sync(this.data.now);

      this.form = this.querySelector('[data-tour-form]');
      this.els = {
        dates: this.querySelector('[data-tour-dates]'),
        methods: this.querySelector('[data-tour-methods]'),
        consent: this.querySelector('[data-tour-consent]'),
        consentInput: this.querySelector('[data-tour-input="consent"]'),
        qty: this.querySelector('[data-tour-input="qty"]'),
        variantId: this.querySelector('[data-tour-variant-id]'),
        formWrap: this.querySelector('[data-tour-form-wrap]'),
        empty: this.querySelector('[data-tour-empty]'),
        status: this.querySelector('[data-tour-status]'),
        formError: this.querySelector('[data-tour-form-error]'),
        submit: this.querySelector('[data-tour-submit]'),
        bar: this.querySelector('[data-tour-bar]')
      };
      this.busy = false;
      this.formInView = false;
      this.hasOpen = false;

      this.form.addEventListener('change', this.onChange.bind(this));
      this.form.addEventListener('input', this.onInput.bind(this));
      this.form.addEventListener('focusout', this.onBlur.bind(this));
      this.form.addEventListener('submit', this.onSubmit.bind(this));

      this.render();
      this.observeForm();
      this.setHeaderOffset();
      window.addEventListener('resize', this.setHeaderOffset);
      this.refresh(false);

      // 表示中に締切を迎えた日程を消す
      this.timer = setInterval(this.render.bind(this), 60 * 1000);

      // チェックアウトから「戻る」で bfcache から復帰したとき
      window.addEventListener(
        'pageshow',
        function (event) {
          if (!event.persisted) return;
          this.setBusy(false);
          this.refresh(false);
        }.bind(this)
      );
    }

    disconnectedCallback() {
      clearInterval(this.timer);
      if (this.observer) this.observer.disconnect();
      document.body.classList.remove('tour-bar-active');
    }

    /* ----- 最新在庫の取得（Section Rendering API） ----- */

    async refresh(announceAlways) {
      var url =
        this.dataset.url +
        '?section_id=' +
        encodeURIComponent(this.dataset.sectionFile) +
        '&_=' +
        Date.now(); // CDN キャッシュを避ける

      try {
        var res = await fetch(url, { credentials: 'same-origin', cache: 'no-store' });
        if (!res.ok) throw new Error('HTTP ' + res.status);
        var doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        var fresh = readData(doc);
        if (!fresh) throw new Error('no data');

        var changed = stockKey(fresh) !== stockKey(this.data);
        clock.sync(fresh.now);

        // 日程そのものが増減していたら（キャッシュされたページが古い）、カード一覧を差し替える
        var freshList = doc.querySelector('[data-tour-dates]');
        if (freshList && datesKey(fresh) !== datesKey(this.data)) {
          var selected = this.selectedDate();
          this.els.dates.innerHTML = freshList.innerHTML;
          if (selected) {
            var input = this.els.dates.querySelector('input[value="' + CSS.escape(selected) + '"]');
            if (input && !input.disabled) input.checked = true;
          }
        }

        this.data = fresh;
        this.render();

        if (changed || announceAlways) {
          var msg = '残枠を最新の情報に更新しました。';
          var v = this.selectedVariant();
          if (v) msg += '選択中の日程・参加方法の残りは' + Math.max(0, v.stock) + '名です。';
          this.announce(msg);
        }
      } catch (e) {
        // 取得に失敗したときは埋め込みの値のまま使う
      }
    }

    /* ----- 描画 ----- */

    render() {
      var schedule = buildSchedule(this.data);
      var openList = schedule.list.filter(function (e) {
        return isOpen(e.date);
      });
      var lostSelection = false;

      // 日程カード
      this.els.dates.querySelectorAll('[data-date]').forEach(function (card) {
        var entry = schedule.byDate[card.dataset.date];
        var input = card.querySelector('input');
        var show = !!entry && isOpen(entry.date);
        card.hidden = !show;
        if (!show) {
          if (input.checked) lostSelection = true;
          input.checked = false;
          return;
        }
        input.disabled = entry.total === 0;
        if (input.disabled && input.checked) {
          input.checked = false;
          lostSelection = true;
        }
        card.querySelectorAll('[data-method-badge]').forEach(function (badge) {
          var method = badge.dataset.methodBadge;
          var n = entry.stocks[method] || 0;
          badge.textContent = method + ' ' + (n > 0 ? '残' + n : '満席');
          badge.classList.toggle('tour-badge--full', n === 0);
        });
      });

      var hasOpen = openList.length > 0;
      this.els.formWrap.hidden = !hasOpen;
      this.els.empty.hidden = hasOpen;

      // 参加方法
      var date = this.selectedDate();
      var entry = date ? schedule.byDate[date] : null;
      this.els.methods.hidden = !entry;
      this.els.methods.querySelectorAll('input[name="tour-method"]').forEach(function (input) {
        var n = entry ? entry.stocks[input.value] || 0 : 0;
        var badge = input.parentElement.querySelector('[data-method-stock]');
        input.disabled = n === 0;
        if (input.disabled && input.checked) input.checked = false;
        if (badge) {
          badge.textContent = n > 0 ? '残' + n + '名' : '満席';
          badge.classList.toggle('tour-badge--full', n === 0);
        }
      });

      // 飲酒に関する同意（自家用車のときだけ）
      var needConsent = this.selectedMethod() === CAR_METHOD;
      this.els.consent.hidden = !needConsent;
      this.els.consentInput.disabled = !needConsent;
      if (!needConsent) this.setError('consent', '');

      // 人数
      var variant = this.selectedVariant();
      this.els.variantId.value = variant ? variant.id : '';
      this.renderQty(variant ? Math.max(0, variant.stock) : 0, !!variant);

      // 次回開催の表示（ヒーロー・CTA・固定バー）
      var text = { short: nextText(nextEntry(openList), 'short'), long: nextText(nextEntry(openList), 'long') };
      document.querySelectorAll('[data-tour-next]').forEach(function (el) {
        var t = text[el.dataset.tourNext] || '';
        if (el.textContent !== t) el.textContent = t;
        el.hidden = !t;
      });

      this.hasOpen = hasOpen;
      this.updateBar();

      if (lostSelection) this.announce(MESSAGES.lostSelection);
    }

    renderQty(max, hasVariant) {
      var select = this.els.qty;
      var key = hasVariant ? String(max) : 'none';
      if (select.dataset.max === key) return;
      select.dataset.max = key;

      var prev = parseInt(select.value, 10) || 0;
      var placeholder = !hasVariant ? '日程と参加方法を先にお選びください' : max > 0 ? '選択してください' : '満席';
      select.innerHTML = '';
      select.add(new Option(placeholder, ''));
      for (var i = 1; i <= max; i++) select.add(new Option(i + '名', String(i)));
      select.disabled = !hasVariant || max === 0;

      if (prev && prev <= max) {
        select.value = String(prev);
      } else if (prev) {
        this.setError('qty', MESSAGES.qtyOver);
      }
    }

    updateBar() {
      var show = this.hasOpen && !this.formInView;
      this.els.bar.hidden = !show;
      document.body.classList.toggle('tour-bar-active', show);
    }

    observeForm() {
      if (!('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver(
        function (entries) {
          // まとめて通知されたときは最新の状態を使う
          this.formInView = entries[entries.length - 1].isIntersecting;
          this.updateBar();
        }.bind(this)
      );
      this.observer.observe(this.querySelector('.tour-booking__anchor'));
    }

    // 固定ヘッダーの高さぶん、アンカー移動の位置をずらす
    setHeaderOffset() {
      var header = document.querySelector('.section-header');
      if (header) {
        document.documentElement.style.setProperty('--tour-header-offset', header.offsetHeight + 'px');
      }
    }

    announce(message) {
      var status = this.els.status;
      status.textContent = '';
      // 同じ文言でも読み上げられるよう、一度空にしてから入れる
      setTimeout(function () {
        status.textContent = message;
      }, 100);
    }

    /* ----- 選択状態 ----- */

    selectedDate() {
      var c = this.els.dates.querySelector('input[name="tour-date"]:checked');
      return c ? c.value : null;
    }

    selectedMethod() {
      var c = this.els.methods.hidden ? null : this.els.methods.querySelector('input[name="tour-method"]:checked');
      return c ? c.value : null;
    }

    selectedVariant() {
      var date = this.selectedDate();
      var method = this.selectedMethod();
      if (!date || !method) return null;
      for (var i = 0; i < this.data.variants.length; i++) {
        var v = this.data.variants[i];
        if (v.date === date && v.method === method) return v;
      }
      return null;
    }

    /* ----- エラー表示 ----- */

    setError(key, message) {
      var el = this.querySelector('[data-tour-error="' + key + '"]');
      if (!el) return;
      el.textContent = message;
      el.hidden = !message;

      var target =
        this.querySelector('[data-tour-input="' + key + '"]') || this.querySelector('[data-tour-group="' + key + '"]');
      if (target) {
        if (message) target.setAttribute('aria-invalid', 'true');
        else target.removeAttribute('aria-invalid');
      }
    }

    showFormError(message) {
      this.els.formError.textContent = message;
      this.els.formError.hidden = !message;
    }

    validateField(key) {
      var input = this.querySelector('[data-tour-input="' + key + '"]');
      if (!input || !VALIDATORS[key]) return '';
      var message = VALIDATORS[key](input.value);
      this.setError(key, message);
      return message;
    }

    // すべて検証し、最初のエラー箇所（フォーカス先）を返す
    validateAll() {
      var firstInvalid = null;
      var mark = function (key, message, focusTarget) {
        this.setError(key, message);
        if (message && !firstInvalid) firstInvalid = focusTarget;
      }.bind(this);

      var date = this.selectedDate();
      mark('date', date ? '' : MESSAGES.date, this.els.dates.querySelector('.tour-date:not([hidden]) input:not(:disabled)'));

      var method = this.selectedMethod();
      if (date) {
        mark('method', method ? '' : MESSAGES.method, this.els.methods.querySelector('input:not(:disabled)'));
      }

      if (method === CAR_METHOD) {
        mark('consent', this.els.consentInput.checked ? '' : MESSAGES.consent, this.els.consentInput);
      }

      var variant = this.selectedVariant();
      var qty = parseInt(this.els.qty.value, 10) || 0;
      var qtyMessage = '';
      if (variant) {
        if (!qty) qtyMessage = MESSAGES.qty;
        else if (qty > variant.stock) qtyMessage = MESSAGES.qtyOver;
      }
      mark('qty', qtyMessage, this.els.qty);

      ['name', 'kana', 'tel'].forEach(
        function (key) {
          mark(key, this.validateField(key), this.querySelector('[data-tour-input="' + key + '"]'));
        }.bind(this)
      );

      return firstInvalid;
    }

    /* ----- イベント ----- */

    onChange(event) {
      var t = event.target;
      if (t.name === 'tour-date') {
        this.setError('date', '');
        this.showFormError('');
        this.render();
      } else if (t.name === 'tour-method') {
        this.setError('method', '');
        this.showFormError('');
        this.render();
      } else if (t.dataset.tourInput === 'qty') {
        this.setError('qty', '');
      } else if (t.dataset.tourInput === 'consent') {
        this.setError('consent', t.checked ? '' : MESSAGES.consent);
      }
    }

    // エラー表示中の欄は入力のたびに再検証する
    onInput(event) {
      var key = event.target.dataset.tourInput;
      var err = key && this.querySelector('[data-tour-error="' + key + '"]');
      if (err && !err.hidden) this.validateField(key);
    }

    onBlur(event) {
      var t = event.target;
      var key = t.dataset.tourInput;
      if (!VALIDATORS[key] || !t.value) return;
      if (key === 'tel') t.value = normalizeTel(t.value);
      this.validateField(key);
    }

    async onSubmit(event) {
      event.preventDefault();
      if (this.busy) return;
      this.showFormError('');

      var firstInvalid = this.validateAll();
      if (firstInvalid) {
        firstInvalid.focus();
        return;
      }

      // 送信直前にもう一度締切を判定
      var variant = this.selectedVariant();
      if (!isOpen(variant.date)) {
        this.showFormError(MESSAGES.closed);
        this.render();
        return;
      }

      var properties = {
        '代表者氏名': this.querySelector('[data-tour-input="name"]').value.trim(),
        'フリガナ': this.querySelector('[data-tour-input="kana"]').value.trim(),
        '電話番号': normalizeTel(this.querySelector('[data-tour-input="tel"]').value)
      };
      if (variant.method === CAR_METHOD) {
        properties['飲酒に関する同意'] = this.els.consentInput.value;
      }

      this.setBusy(true);
      try {
        await this.removeTourLines();
        var res = await fetch(rootUrl() + 'cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: variant.id, quantity: parseInt(this.els.qty.value, 10), properties: properties }]
          })
        });

        if (res.ok) {
          window.location = rootUrl() + 'checkout';
          return; // 遷移するまでボタンは押せないままにする
        }

        this.setBusy(false);
        if (res.status === 422) {
          this.showFormError(MESSAGES.soldOut);
          this.refresh(true);
        } else {
          this.showFormError(MESSAGES.network);
        }
      } catch (e) {
        this.setBusy(false);
        this.showFormError(MESSAGES.network);
      }
    }

    // やり直しで申込が二重にならないよう、カート内の以前のツアー行だけ外す（他の商品は残す）
    async removeTourLines() {
      var res = await fetch(rootUrl() + 'cart.js', { credentials: 'same-origin' });
      if (!res.ok) return;
      var cart = await res.json();
      var updates = {};
      var productId = this.data.productId;
      cart.items.forEach(function (item) {
        if (item.product_id === productId) updates[item.key] = 0;
      });
      if (!Object.keys(updates).length) return;
      await fetch(rootUrl() + 'cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates })
      });
    }

    setBusy(busy) {
      this.busy = busy;
      var btn = this.els.submit;
      btn.disabled = busy;
      btn.setAttribute('aria-busy', busy ? 'true' : 'false');
      btn.textContent = busy ? '処理中…' : btn.dataset.label;
    }
  }

  customElements.define('tour-booking', TourBooking);
})();
